export default __webpack_public_path__ + "static/media/communityIconMenu.23626856.png";